export function expandChartBounds({
  candle,
  priceMinimum,
  priceMaximum,
}) {
  if (!candle) {
    return {
      priceMinimum,
      priceMaximum,
    };
  }

  const candleLow =
    candle.low == null ? priceMinimum : Number(candle.low);
  const candleHigh =
    candle.high == null ? priceMaximum : Number(candle.high);

  return {
    priceMinimum:
      priceMinimum == null ? candleLow : Math.min(priceMinimum, candleLow),
    priceMaximum:
      priceMaximum == null ? candleHigh : Math.max(priceMaximum, candleHigh),
  };
}
